export const SearchOrderType = {
    DISTANCE: "距離が近い順",
    TOTAL_SPACE_COUNT: "車室数が多い順",
    CURRENT_FEE: "現在料金が安い順",
    CURRENT_MAX_FEE: "現在最大料金が安い順",
  } as const
  type SearchOrderType = typeof SearchOrderType[keyof typeof SearchOrderType]